<template>
    <section class="closure-edit-view">
        <div class="modal-header">
            <h3>Add Closure</h3>
            <p class="required-fields">All fields marked with * are required</p>
        </div>
        <app-form
            ref="closureForm"
            :model="closure"
            :rules="rules"
            @submit.native.prevent="submit">
            <app-alert>School closures are for the future only and cannot be removed.</app-alert>
            <app-form-item label="Title" prop="title">
                <app-input id="title" v-model="closure.title" autofocus/>
            </app-form-item>
            <app-form-item label="Start Date" prop="start_date">
                <app-date-picker
                    id="start_date"
                    v-model="closure.start_date"
                    format="MM/dd/yyyy"/>
            </app-form-item>
            <app-form-item label="End Date" prop="end_date">
                <app-date-picker
                    id="end_date"
                    v-model="closure.end_date"
                    format="MM/dd/yyyy"/>
            </app-form-item>

            <div class="modal-footer">
                <app-button
                    :loading="isSaving"
                    type="primary"
                    native-type="submit"
                    size="large">Save</app-button>
            </div>
        </app-form>
    </section>
</template>
<script>
import moment from 'moment'
import SchoolClosure from '@/store/models/SchoolClosure'

export default {
    name: 'closure-edit-view',
    inject: ['modalOptions'],
    data() {
        return {
            closure: new SchoolClosure,
            isSaving: false,
            rules: {
                title: [
                    {
                        required: true,
                        message: 'Please enter a title',
                        trigger: 'blur'
                    }
                ],
                start_date: [
                    {
                        required: true,
                        message: 'Please enter a start date',
                        trigger: 'blur'
                    }
                ],
                end_date: [
                    {
                        required: true,
                        message: 'Please enter a end date',
                        trigger: 'blur'
                    }
                ]
            },
            pickerOptions: {
                disabledDate1(date) {
                    return moment(date).isBefore()
                }
            }
        }
    },
    methods: {
        submit() {
            this.$refs['closureForm'].validate(valid => {
                if (valid) {
                    this.create()
                }
            })
        },
        create() {
            this.isSaving = true
            this.closure.$create()
                .then(() => {
                    this.isSaving = false
                    this.modalOptions.modalOpen = false
                })
                .catch(() => {
                    this.isSaving = false
                })

            return false
        }
    }
}
</script>

<style lang="stylus"></style>
